import { Reveal } from "./Reveal";
import { ShieldCheck, BadgeCheck, Siren, MapPin } from "lucide-react";

const CHARLESTON_IMG =
  "https://images.unsplash.com/photo-1623608103477-2b90432a3f85?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200";

const values = [
  { icon: Siren, title: "First-Responder Ethos", desc: "We show up fast and treat every home with the same urgency and care we'd give our own." },
  { icon: BadgeCheck, title: "Satisfaction Guaranteed", desc: "If it's not right, we make it right. Every job backed by our guarantee." },
  { icon: ShieldCheck, title: "Licensed & Insured", desc: "Fully insured, professional equipment, and safe soft-wash methods for every surface." },
  { icon: MapPin, title: "Local to Charleston", desc: "Proudly serving all of Charleston, SC and the surrounding Lowcountry communities." },
];

export const Trust = () => (
  <section id="trust" className="py-24 sm:py-32 bg-fr-surface" data-testid="trust-section">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
      <div className="grid lg:grid-cols-2 gap-16 items-center">
        <Reveal className="relative">
          <div className="relative overflow-hidden border border-white/10 aspect-[4/5]">
            <img
              src={CHARLESTON_IMG}
              alt="Charleston SC"
              className="w-full h-full object-cover"
              style={{ filter: "brightness(0.7) contrast(1.05)" }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-fr-black via-transparent to-transparent" />
            <div className="absolute bottom-0 left-0 p-8">
              <span className="fr-mono text-xs tracking-[0.3em] uppercase text-fr-blue-light">Service Area</span>
              <div className="font-display font-bold text-3xl sm:text-4xl mt-2">All of Charleston, SC</div>
            </div>
          </div>
        </Reveal>

        <div>
          <Reveal className="mb-12">
            <span className="fr-mono text-xs tracking-[0.3em] uppercase text-fr-blue-light">/ Why homeowners choose us</span>
            <h2 className="mt-5 font-display font-bold text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-none">
              We treat your home like it{"'"}s ours.
            </h2>
          </Reveal>

          <div className="grid sm:grid-cols-2 gap-6">
            {values.map((v, i) => {
              const Icon = v.icon;
              return (
                <Reveal key={v.title} delay={i * 0.08}>
                  <div
                    data-testid={`value-${i}`}
                    className="bg-fr-black border border-white/10 p-7 h-full hover:border-fr-blue/50 transition-colors duration-300"
                  >
                    <Icon className="text-fr-blue-light mb-5" size={30} />
                    <h3 className="font-display font-semibold text-xl mb-2">{v.title}</h3>
                    <p className="text-white/55 text-sm leading-relaxed">{v.desc}</p>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  </section>
);
